import axios from 'plugins/axios'

export const state = {
  validatedVoucher: {},
  appliedVoucher: null,
  count: 0
}

export const getters = {
  getVoucherByCode: (state, getters, actions) => (code) => {
    return actions.validate(code)
  },
  vouchers (state) {
    return state.count
  },
  getValidatedVoucher (state) {
    return state.validatedVoucher
  },
  getAppliedVoucher (state) {
    return state.appliedVoucher
  }
}

export const mutations = {
  addAppliedVoucher (state, voucher) {
    state.appliedVoucher = voucher

    return state.appliedVoucher
  },
  addValidatedVoucher (state, voucher) {
    state.validatedVoucher = voucher
    return state.validatedVoucher
  },
  addCount (state, count) {
    state.count = count
    return state.count
  }
}

export const actions = {
  async validate ({state, commit}, {code, shopId}) {
    let {data} = await axios.post(`/vouchers/validate?id=${Math.random() * 10}`, {code: code, shopId: shopId})
    commit('addValidatedVoucher', data.data)
    return data.data
  },
  async numVouchers ({state, commit}, {shopId}) {
    let {data} = await axios.post(`/vouchers/count?id=${Math.random() * 10}`, {shopId: shopId})
    commit('addCount', data)
    return data
  }
}



// WEBPACK FOOTER //
// ./client/store/vouchers.js